// Timeline del detalle de validación de servicios.
//
// Reutiliza EXACTAMENTE el diseño, la animación y las cadenas i18n del timeline
// original del detalle de servicio (`Services/DetailService`): el componente
// `Actions` y los helpers `makeGetEventDetails` / `formatServiceDateTime`
// extraídos a `Services/DetailService/utils`.
//
// Única diferencia: se envuelve en un contenedor con la clase `sv-timeline`,
// que sobreescribe los colores de los iconos de estado (completed/pending/
// cancelled) por la paleta ACTUAL del validador (success/warning del tema),
// manteniendo intactos el layout, la animación y los textos i18n originales.
//
// Entradas:
// - service: objeto de `getServiceAdmin` (mismo shape que usa el detalle de
//   servicio). Aporta status, trip, driver, scheduled_start, *_from_system,
//   cancellation_info.
// - timelineData: eventos de `getTripsTimeline` ya aplanados
//   (`trip.map(obj => Object.values(obj)[0])`), igual que en el detalle.
import React, { useMemo } from "react"
import { Actions, makeGetEventDetails, formatServiceDateTime } from "../Services/DetailService/utils"

const ServiceValidationTimeline = ({ service, timelineData }) => {
  // getEventDetails depende del `service` (status/driver/cancelación), por eso
  // se construye por render a partir del service actual.
  const getEventDetails = useMemo(() => makeGetEventDetails(service || {}), [service])

  return (
    <div className="sv-timeline">
      <Actions
        service={service || {}}
        timelineData={timelineData || []}
        getEventDetails={getEventDetails}
        formatDateTime={formatServiceDateTime}
      />
    </div>
  )
}

export default ServiceValidationTimeline
